// src/api/copyApi.js
import { getApi } from './axiosInstance';

// Fetch all copies
export const fetchAllCopies = async () => {
    try {
        const response = await getApi().get('/Copy');
        return response.data;
    } catch (error) {
        console.error('Error fetching copies:', error);
        throw error;
    }
};

// Fetch all old copies
export const fetchAllOldCopies = async () => {
    try {
        const response = await getApi().get('/Copy/GetCopyOld');
        return response.data;
    } catch (error) {
        console.error('Error fetching old copies:', error);
        throw error;
    }
};

// Fetch copy summaries
export const fetchCopySummaries = async () => {
    try {
        const response = await getApi().get('/Copy/FetchCopySummaries');
        return response.data;
    } catch (error) {
        console.error('Error fetching copy summaries:', error);
        throw error;
    }
};

// Fetch specific copy by ID
export const fetchCopyById = async (id) => {
    try {
        console.log('Fetching copy with ID:', id);
        const response = await getApi().get('/Copy/FetchCopyById', {
            params: { id: id }
        });
        console.log('Copy details response:', response.data);
        return response.data;
    } catch (error) {
        console.error(`Error fetching copy with ID ${id}:`, error);
        if (error.response) {
            console.error('Error response:', {
                status: error.response.status,
                data: error.response.data,
                headers: error.response.headers
            });
        }
        throw error;
    }
};

// Fetch copies by Prompt ID
export const fetchCopyByPromptId = async (promptId) => {
    console.log("Fetching copies for prompt ID:", promptId);
    try {
        const response = await getApi().get('/Copy/FetchCopyByPromptId', {
            params: { id: promptId },
        });
        return response.data;
    } catch (error) {
        console.error(`Error fetching copies by Prompt ID ${promptId}:`, error);
        return [];
    }
};

// Create a new copy
export const createCopy = async (copyData) => {
    try {
        const response = await getApi().post('/Copy', copyData);
        return response.data;
    } catch (error) {
        console.error('Error creating copy:', error);
        throw error;
    }
};

// Update an existing copy
export const updateCopy = async (id, copyData) => {
    try {
        const response = await getApi().put(`/Copy/${id}`, copyData);
        return response.data;
    } catch (error) {
        console.error(`Error updating copy with ID ${id}:`, error);
        throw error;
    }
};

// Delete a copy
export const deleteCopy = async (id) => {
    try {
        console.log('Attempting to delete copy with ID:', id);
        const response = await getApi().delete('/Copy', {
            params: { id: id }
        });
        console.log('Delete response:', response.data);
        return response.data;
    } catch (error) {
        console.error(`Error deleting copy with ID ${id}:`, error);
        if (error.response) {
            console.error('Error response:', {
                status: error.response.status,
                data: error.response.data,
                headers: error.response.headers
            });
        }
        throw error;
    }
};

// Redo a copy with specific text range and prompt
export const redoCopy = async (copyId, redoPrompt, charRange) => {
    try {
        console.log('Redoing copy with ID:', copyId, 'Prompt:', redoPrompt, 'Range:', charRange);
        const response = await getApi().get('/Copy/RedoCopy', {
            params: {
                copyId: copyId,
                redoPrompt: redoPrompt,
                startChar: charRange.start,
                endChar: charRange.end
            }
        });
        console.log('Redo copy response:', response.data);
        return response.data;
    } catch (error) {
        console.error(`Error redoing copy with ID ${copyId}:`, error);
        if (error.response) {
            console.error('Error response:', {
                status: error.response.status,
                data: error.response.data,
                headers: error.response.headers
            });
        }
        throw error;
    }
};